<template>
  <!-- Consultant wizard -->
  <div class="wizard" v-if="getAccountType == 1 || getAccountType == 4">
    <!-- Starting logo section -->
    <section class="logo-section">
      <img src="../assets/images/logo/new_logo.svg" width="70" />
    </section>
    <!-- End of logo section -->

    <!-- Starting of wizard section -->
    <section class="wizard-section">
      <div class="wizard-header">
        <h3>A few steps to get started...</h3>
      </div>
      <div class="wizard-body">
        <!-- Starting of steper -->
        <div class="wizard-steper">
          <div class="steper-items">
            <div class="steper-item" v-bind:class="{ active: wizard_tabs[0].is_active }">
              <span class="steper-number" v-bind:class="{ done: wizard_tabs[0].is_done }">1</span>
              <span class="steper-success" v-bind:class="{ done: wizard_tabs[0].is_done }">
                <span class="mdi mdi-check"></span>
              </span>
            </div>

            <div class="steper-divider active"></div>
            <div class="steper-item" v-bind:class="{ active: wizard_tabs[2].is_active }">
              <span class="steper-number" v-bind:class="{ done: wizard_tabs[2].is_done }">2</span>
              <span class="steper-success" v-bind:class="{ done: wizard_tabs[2].is_done }">
                <span class="mdi mdi-check"></span>
              </span>
            </div>
          </div>
        </div>
        <!-- Ending of steper -->

        <!-- Starting of wazard tabs -->
        <div class="wizard-tabs">
          <div class="wizard-tab" v-show="wizard_tabs[0].enabled" v-animate-css="'zoomIn'">
            <div class="wizard-tab-header">
              <h5>Personal information</h5>
            </div>
            <div class="wizard-tab-body">
              <div class="wizard-input-group col-2">
                <div class="input">
                  <input type="text" class="wizard-input" placeholder="Add your phone number" name="name"
                    v-model="consultant.phone" />
                </div>
                <div class="input">
                  <map-helper v-model="consultant.address"></map-helper>
                </div>
              </div>
              <div class="wizard-input-group" style="display: flex; justify-content: center">
                <div class="input profile-image">
                  <upload @onFileSelected="setConsultantProfileLogo" caption="Profile image" :crop="true" />
                </div>
              </div>
            </div>
            <div class="wizard-tab-footer">
              <c-button class="wizard-btn-next" :loading="loading_consultant" @click="saveConsultantInfo()"
                type="submit">Next</c-button>
              <button @click.prevent="tabSuccess(0), nextTab(2)" class="wizard-btn-skip">
                Skip
              </button>
            </div>
          </div>

          <!-- Next tab -->
          <div class="wizard-tab" v-show="wizard_tabs[2].enabled" v-animate-css="'fadeIn'">
            <div class="wizard-tab-header"></div>

            <div class="wizard-tab-body">
              <div class="success-avatar">
                <h2>Success!</h2>
                <img src="@/assets/images/success_avatar.svg" alt />
              </div>
            </div>
            <div class="wizard-tab-footer">
              <button class="wizard-btn-next" @click="finish(1)" type="submit">
                Finish
              </button>
              <div class="sub-option"></div>
            </div>
          </div>
        </div>
        <!-- Ending of wazard tabs -->
      </div>
    </section>

    <!-- End of wizard section -->
  </div>

  <!-- Customer wizard -->
  <div class="wizard" v-else-if="getAccountType == 2">
    <!-- Starting logo section -->
    <section class="logo-section">
      <img src="../assets/images/logo/new_logo.svg" width="70" />
    </section>
    <!-- End of logo section -->

    <!-- Starting of wizard section -->
    <section class="wizard-section">
      <div class="wizard-header">
        <h3>A few steps to get started...</h3>
      </div>
      <div class="wizard-body">
        <!-- Starting of steper -->
        <div class="wizard-steper">
          <div class="steper-items">
            <div class="steper-item" v-bind:class="{ active: wizard_tabs[0].is_active }">
              <span class="steper-number" v-bind:class="{ done: wizard_tabs[0].is_done }">1</span>
              <span class="steper-success" v-bind:class="{ done: wizard_tabs[0].is_done }">
                <span class="mdi mdi-check"></span>
              </span>
            </div>
            <div class="steper-divider active"></div>
            <div class="steper-item" v-bind:class="{ active: wizard_tabs[1].is_active }">
              <span class="steper-number" v-bind:class="{ done: wizard_tabs[1].is_done }">2</span>
              <span class="steper-success" v-bind:class="{ done: wizard_tabs[1].is_done }">
                <span class="mdi mdi-check"></span>
              </span>
            </div>
          </div>
        </div>
        <!-- Ending of steper -->

        <!-- Starting of wazard tabs -->
        <div class="wizard-tabs">
          <div class="wizard-tab" v-show="wizard_tabs[0].enabled" v-animate-css="'zoomIn'">
            <div class="wizard-tab-header">
              <h5>About the organisation</h5>
            </div>
            <form @submit.prevent="nextTabWithSuccess()" data-vv-scope="form-1">
              <div class="wizard-tab-body">
                <div class="wizard-input-group col-2">
                  <div class="input">
                    <input type="text" class="wizard-input" v-model="customer.names" placeholder="Name" name="name"
                      v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.name')">Name is required</span>
                  </div>

                  <div class="input">
                    <input type="text" class="wizard-input" v-model="customer.customer_name" placeholder="Customer name"
                      name="customer_name" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.customer_name')">Customer name is required</span>
                  </div>
                </div>

                <div class="wizard-input-group col-2">
                  <div class="input">
                    <input type="text" class="wizard-input" v-model="customer.email"
                      placeholder="Personal e-mail at company" name="email" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.email')">Email is required</span>
                  </div>

                  <div class="input">
                    <input type="text" class="wizard-input" v-model="customer.phone" placeholder="Phone" name="phone"
                      v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.phone')">Phone number is required</span>
                  </div>
                </div>
              </div>

              <div class="wizard-tab-footer">
                <button class="wizard-btn-next" type="submit">Next</button>
                <button @click.prevent="tabSuccess(0), nextTab(1)" class="wizard-btn-skip">
                  Skip
                </button>
              </div>
            </form>
          </div>
          <!-- Next tab -->
          <div class="wizard-tab" v-show="wizard_tabs[1].enabled" v-animate-css="'fadeIn'">
            <div class="wizard-tab-header">
              <h5>About the organisation</h5>
            </div>
            <div class="wizard-tab-body">
              <div class="wizard-input-group">
                <div class="input">
                  <label>Add Customer Description</label>
                  <textarea type="text" class="wizard-input" v-model="customer.customer_description" placeholder
                    style="height: 100px"></textarea>
                </div>
              </div>
              <div class="wizard-input-group sec-company-third-row">
                <div class="input">
                  <label>Logo Image</label>
                  <div class="uploaded-image-preview">
                    <upload @onFileSelected="setCustomerLogo" :crop="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-tab-footer">
              <consultfied-button @click="submitCustomerInformation()" class="wizard-btn-finish"
                :loading="loading">Finish</consultfied-button>
              <button class="wizard-btn-skip" @click="tabSuccess(1), nextTab(2)">
                Skip
              </button>
            </div>
          </div>

          <!-- Next tab -->
          <div class="wizard-tab" v-show="wizard_tabs[2].enabled" v-animate-css="'fadeIn'">
            <div class="wizard-tab-header">
              <h5>About the organisation</h5>
            </div>
            <div class="wizard-tab-body">
              <div class="success-avatar">
                <h2>Success!</h2>
                <img src="@/assets/images/success_avatar.svg" alt />
              </div>
            </div>
            <div class="wizard-tab-footer">
              <button @click="finish(2)" class="wizard-btn-finish">
                Proceed
              </button>
            </div>
          </div>
        </div>
        <!-- Ending of wazard tabs -->
      </div>
    </section>

    <!-- End of wizard section -->
  </div>

  <!-- Company wizard -->
  <div class="wizard" v-else-if="getAccountType == 3">
    <!-- Starting logo section -->
    <section class="logo-section">
      <img src="../assets/images/logo/new_logo.svg" width="70" />
    </section>
    <!-- End of logo section -->

    <!-- Starting of wizard section -->
    <section class="wizard-section">
      <div class="wizard-header">
        <h3>A few steps to get started...</h3>
      </div>
      <div class="wizard-body">
        <!-- Starting of steper -->
        <div class="wizard-steper">
          <div class="steper-items">
            <div class="steper-item" v-bind:class="{ active: wizard_tabs[0].is_active }">
              <span class="steper-number" v-bind:class="{ done: wizard_tabs[0].is_done }">1</span>
              <span class="steper-success" v-bind:class="{ done: wizard_tabs[0].is_done }">
                <span class="mdi mdi-check"></span>
              </span>
              <span class="steper-label">Company</span>
            </div>
            <div class="steper-divider active"></div>
            <div class="steper-item" v-bind:class="{ active: wizard_tabs[1].is_active }">
              <span class="steper-number" v-bind:class="{ done: wizard_tabs[1].is_done }">2</span>
              <span class="steper-success" v-bind:class="{ done: wizard_tabs[1].is_done }">
                <span class="mdi mdi-check"></span>
              </span>
              <span class="steper-label">Manager</span>
            </div>
          </div>
        </div>
        <!-- Ending of steper -->

        <!-- Starting of wazard tabs -->
        <div class="wizard-tabs">
          <div class="wizard-tab" v-show="wizard_tabs[0].enabled" v-animate-css="'zoomIn'">
            <div class="wizard-tab-header">
              <h5>Company information</h5>
            </div>
            <form @submit.prevent="nextTabWithSuccess()" data-vv-scope="form-1">
              <div class="wizard-tab-body">
                <div class="wizard-input-group col-2">
                  <div class="input">
                    <input type="text" class="wizard-input" v-model="company.company_name" placeholder="Company name"
                      name="company_name" v-validate="'required'" />
                    <span class="error_alert" v-if="errors.has('form-1.company_name')">Company name is required</span>
                  </div>
                  <div class="input">
                    <map-helper v-model="company.company_address"></map-helper>
                  </div>
                </div>
                <div class="wizard-input-group company-second-row">
                  <div class="input">
                    <textarea type="text" style="height: 221px" class="wizard-input" v-model="company.company_description"
                      placeholder="Company description" name="company_description" v-validate="'required'"></textarea>
                    <span class="error_alert" v-if="errors.has('form-1.company_description')">Company description is
                      required</span>
                  </div>
                  <div class="input">
                    <upload @onFileSelected="setCompanyLogo" caption="Logo image" :crop="false" />
                  </div>
                </div>
              </div>
              <div class="wizard-tab-footer">
                <button class="wizard-btn-next" type="submit">Next</button>
                <button @click.prevent="tabSuccess(0), nextTab(1)" class="wizard-btn-skip">
                  Skip
                </button>
              </div>
            </form>
          </div>
          <!-- Next tab -->
          <div class="wizard-tab" v-show="wizard_tabs[1].enabled" v-animate-css="'fadeIn'">
            <div class="wizard-tab-header">
              <h5>Manager / Supplier information</h5>
            </div>
            <div class="wizard-tab-body">
              <div class="wizard-input-group col-2">
                <div class="input">
                  <input type="text" class="wizard-input" v-model="company.first_name" placeholder="First name"
                    name="name" v-validate="'required'" />
                  <span class="error_alert" v-if="errors.has('form-1.first_name')">First name is required</span>
                </div>
                <div class="input">
                  <input type="text" class="wizard-input" v-model="company.last_name" placeholder="Last name"
                    name="last_name" v-validate="'required'" />
                  <span class="error_alert" v-if="errors.has('form-1.last_name')">Last name is required</span>
                </div>
              </div>
              <div class="wizard-input-group col-2">
                <div class="input">
                  <input type="text" class="wizard-input" v-model="company.phone" placeholder="Phone number" name="phone"
                    v-validate="'required'" />
                  <span class="error_alert" v-if="errors.has('form-1.phone')">Phone is required</span>
                </div>
                <div class="input">
                  <map-helper v-model="company.address"></map-helper>
                </div>
              </div>
              <div class="wizard-input-group sec-company-third-row">
                <div class="input" style="height: 200px; width: 200px">
                  <upload @onFileSelected="setProfileLogo" caption="Profile image" :crop="false" />
                </div>
              </div>
            </div>
            <div class="wizard-tab-footer">
              <consultfied-button @click="submitCompanyInformation()" class="wizard-btn-finish"
                :loading="loading">Finish</consultfied-button>
              <div class="sub-option">
                <button class="wizard-btn-back" @click="prevTab(0)">
                  Back
                </button>
                <span class="sepalator">|</span>
                <button class="wizard-btn-skip" @click="submitCompanyInformation(), tabSuccess(1), nextTab(2)">
                  Skip
                </button>
              </div>
            </div>
          </div>

          <!-- Next tab -->
          <div class="wizard-tab" v-show="wizard_tabs[2].enabled" v-animate-css="'fadeIn'">
            <div class="wizard-tab-header"></div>
            <div class="wizard-tab-body">
              <div class="success-avatar">
                <h2>Success!</h2>
                <img src="@/assets/images/success_avatar.svg" alt />
              </div>
            </div>
            <div class="wizard-tab-footer">
              <button @click="finish(3)" class="wizard-btn-finish">
                Proceed
              </button>
            </div>
          </div>
        </div>
        <!-- Ending of wazard tabs -->
      </div>
    </section>

    <!-- End of wizard section -->
  </div>
</template>

<script>
import upload from "../components/Partials/Uploader";
import { mapGetters, mapActions } from "vuex";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";

export default {
  name: "new_wizard",
  components: {
    upload,
    consultfiedButton,
  },
  data() {
    return {
      wizard_tabs: [
        // First tab
        {
          enabled: false,
          is_active: false,
          is_done: false,
        },
        // Second tab
        {
          enabled: false,
          is_active: false,
          is_done: false,
        },
        // Second tab
        {
          enabled: false,
          is_active: false,
          is_done: false,
        },
      ],
      consultant: {
        phone: "",
        address: "",
        description: "",
        profile_image: null,
      },
      loading_consultant: false,
      customer: {
        names: "",
        customer_name: "",
        email: "",
        phone: "",
        customer_description: "",
        customer_logo: null,
      },
      customer_loading: false,
      company: {
        company_name: "",
        company_address: "",
        company_description: "",
        company_image: null,
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        profile_image: null,
      },
      company_loading: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters([
      "getMeProfile",
      "getSearchedPeople",
      "getCountries",
      "getCities",
    ]),
    getAccountType() {
      let vm = this;
      return vm.$cookies.get("account-type");
    },
  },
  mounted() {
    let vm = this;
    if (vm.getAccountType) {
      vm.getData();
      vm.nextTab(0);
    } else {
      vm.$router.push({ path: "/feeds" });
    }
  },
  methods: {
    ...mapActions(["GET_ME_PROFILE_DATA"]),
    setConsultantProfileLogo(file) {
      let vm = this;
      if (file) {
        vm.consultant.profile_image = file;
      } else {
        vm.consultant.profile_image = null;
      }
    },
    nextTabWithSuccess() {
      let vm = this;
      vm.$validator.validateAll("form-1").then((isError) => {
        if (isError === true) {
          vm.tabSuccess(0);
          vm.nextTab(1);
        }
      });
    },
    finish(account_type) {
      let vm = this;
      if (account_type == "1") {
        vm.$router.push({ name: "consultant-profile" });
      } else if (account_type == "2") {
        vm.$router.push({ name: "profile-customer" });
      } else if (account_type == "3") {
        vm.$router.push({ name: "crm" });
      }
    },
    getData() {
      this.$store.dispatch("GET_ME_PROFILE_DATA");
    },
    tabSuccess(index) {
      let vm = this;
      vm.wizard_tabs[index].enabled = false;
      vm.wizard_tabs[index].is_active = true;
      vm.wizard_tabs[index].is_done = true;
    },
    nextTab(index) {
      let vm = this;
      vm.wizard_tabs[index].enabled = true;
      vm.wizard_tabs[index].is_active = true;
      vm.wizard_tabs[index].is_done = false;
    },
    prevTab(index) {
      let vm = this;
      vm.wizard_tabs[index + 1].enabled = false;
      vm.wizard_tabs[index + 1].is_active = false;
      vm.wizard_tabs[index + 1].is_done = false;

      vm.wizard_tabs[index].enabled = true;
      vm.wizard_tabs[index].is_active = true;
      vm.wizard_tabs[index].is_done = false;
    },
    saveConsultantInfo() {
      let vm = this;
      let form_data = new FormData();
      const rules = {
        phone: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Phone can not be empty";
          },
        },
        address: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Please add you location";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.consultant, rules)) {
        vm.loading_consultant = true;
        form_data.append("phone", vm.consultant.phone);
        form_data.append("address", vm.consultant.address);
        form_data.append("description", vm.consultant.description);
        if (vm.consultant.profile_image) {
          form_data.append(
            "profile_image",
            vm.consultant.profile_image,
            vm.consultant.profile_image.name
          );
        }
        vm.$store
          .dispatch("ADD_NEW_CONSULTANT_INFO", form_data)
          .then((response) => {
            vm.tabSuccess(0);
            vm.nextTab(2);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Your information is added",
              type: "success",
              duration: 3000,
            });
            vm.loading_consultant = false;
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something wrong, please try again!!!",
              type: "warn",
              duration: 3000,
            });
            vm.loading_consultant = false;
            console.log(error);
          });
      }
    },
    submitCustomerInformation() {
      let vm = this;
      let form_data = new FormData();
      vm.customer_loading = true;
      form_data.append("names", vm.customer.names);
      form_data.append("customer_name", vm.customer.customer_name);
      form_data.append("email", vm.customer.email);
      form_data.append("phone", vm.customer.phone);
      form_data.append(
        "customer_description",
        vm.customer.customer_description
      );
      if (vm.customer.customer_logo) {
        form_data.append(
          "customer_logo",
          vm.customer.customer_logo,
          vm.customer.customer_logo.name
        );
      }
      vm.$store
        .dispatch("ADD_NEW_CUSTOMER", form_data)
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Your information is added",
            type: "success",
            duration: 3000,
          });
          vm.customer_loading = false;
          vm.tabSuccess(1);
          vm.nextTab(2);
        })
        .catch((error) => {
          vm.customer_loading = false;
          console.log(error);
        });
    },
    submitCompanyInformation() {
      let vm = this;
      let form_data = new FormData();
      vm.loading = true;
      form_data.append("company_name", vm.company.company_name);
      form_data.append("company_address", vm.company.company_address);
      form_data.append("company_description", vm.company.company_description);
      form_data.append("first_name", vm.company.first_name);
      form_data.append("last_name", vm.company.last_name);
      form_data.append("phone", vm.company.phone);
      form_data.append("address", vm.company.address);
      if (vm.company.company_image) {
        form_data.append(
          "company_logo",
          vm.company.company_image,
          vm.company.company_image.name
        );
      }
      if (vm.company.profile_image) {
        form_data.append(
          "profile_image",
          vm.company.profile_image,
          vm.company.profile_image.name
        );
      }

      vm.$store
        .dispatch("ADD_COMPANY_MANAGER_INFO", form_data)
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Your information is added",
            type: "success",
            duration: 3000,
          });
          vm.loading = false;
          vm.tabSuccess(1);
          vm.nextTab(2);
        })
        .catch((error) => {
          vm.loading = false;
        });
    },
    setCustomerLogo(file) {
      let vm = this;
      if (file) {
        vm.customer.customer_logo = file;
      }
    },
    setProfileLogo(file) {
      let vm = this;
      if (file) {
        vm.company.profile_image = file;
      }
    },
    setCompanyLogo(file) {
      let vm = this;
      if (file) {
        vm.company.company_image = file;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets/";
@import "../styles/main";

.wizard {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  overflow: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 30px;

  @media (min-width: 300px) and (max-width: 630px) {
    background: #fff;
    padding-top: 0px;
    align-items: unset;
  }

  .logo-section {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 10px;
    height: 91px;
  }

  .wizard-section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    @media (min-width: 300px) and (max-width: 630px) {
      height: calc(100% - 91px);
      align-items: unset;
    }

    .wizard-header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      color: #1ba5a4;

      @media (min-width: 300px) and (max-width: 630px) {
        height: 60px;
      }

      h3 {}
    }

    .wizard-body {
      width: 800px;
      min-height: 400px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid #e4e4e4;
      border-radius: 5px;
      opacity: 0.97;
      padding-bottom: 10px;

      @media (min-width: 300px) and (max-width: 630px) {
        border: none;
        width: 100%;
        height: calc(100% - 60px);
        min-height: unset;
        padding-bottom: 0px;
        display: flex;
        flex-direction: column;
      }

      .wizard-steper {
        display: flex;
        align-items: center;
        justify-content: center;

        .steper-items {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 90px;

          .steper-item {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            border: 2px solid #cecece;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            span.steper-number {
              font-size: 25px;
              letter-spacing: 0;
              color: #cecece;

              margin-top: 10px;
              position: relative;
              top: -3px;
            }

            .steper-success {
              display: none;
            }

            .steper-label {
              position: absolute;
              top: 45px;
              font-size: 11px;
            }
          }

          .steper-item.active {
            border: 2px solid #04a5a5;

            .steper-number {
              color: #1ba5a4;

              position: relative;
              top: -3px;
            }

            .steper-number.done {
              display: none;
            }

            .steper-success {
              display: none;
            }

            .steper-success.done {
              display: block;

              .mdi {
                color: #1ba5a4;
                font-size: 38px;
                position: relative;
                top: 2px;
              }
            }

            .steper-label {
              position: absolute;
              top: 45px;
              font-size: 11px;
              color: #1ba5a4;
            }
          }

          .steper-divider {
            width: 40px;
            border-top: 2px solid #cecece;
          }

          .steper-divider.active {
            border-top: 2px solid #04a5a5;
          }
        }
      }

      .wizard-tabs {
        .wizard-tab {
          .wizard-tab-header {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 10px;
            padding-bottom: 10px;

            h5 {
              color: #1ba5a4;
            }
          }

          .wizard-tab-body {
            padding-left: 50px;
            padding-right: 50px;

            @media (min-width: 300px) and (max-width: 630px) {
              padding-left: 40px;
              padding-right: 40px;
              padding-top: 30px;
            }

            .success-avatar {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              flex-direction: column;
              margin-left: -19px;

              h2 {}

              img {
                width: 300px;
              }
            }

            .wizard-input-group {
              margin-bottom: 18px;
              display: grid;
              grid-column-gap: 20px;

              .input {
                display: flex;
                flex-direction: column;
                z-index: unset !important;

                &.profile-image {
                  height: 200px;
                  width: 200px;

                  @media (min-width: 300px) and (max-width: 630px) {
                    height: 100px;
                    width: 100%;
                  }
                }

                .wizard-date-picker {
                  background: #ffffff 0% 0% no-repeat padding-box;
                  border: 1px solid #d4d4d4;
                  border-radius: 5px;
                  min-height: 52px;
                  width: 100%;
                  padding: 5px 20px;
                  color: #000;
                  font-size: 14px;
                }

                .wizard-input {
                  background: #ffffff 0% 0% no-repeat padding-box;
                  border: 1px solid #d4d4d4;
                  border-radius: 5px;
                  min-height: 52px;
                  width: 100%;
                  padding: 5px 20px;
                  color: #000;
                  font-size: 14px;
                }

                .wizard-input:focus {
                  outline: none;
                }

                label {
                  font-size: 15px;
                  color: #4d4d4d;
                  margin-bottom: 10px;
                  display: block;
                }
              }

              .uploaded-image-preview {
                padding-top: 15px;
                padding-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .image-preview {
                  outline-style: dashed;
                  outline-color: #ccc;
                  outline-width: 1px;
                  width: 100%;
                  height: 170px;
                  border-radius: 5px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;

                  .mdi {
                    color: #ccc;
                    font-size: 40px;
                  }
                }

                .btn-upload {
                  width: 100%;
                  height: 43px;
                  border-radius: 5px;
                  border: none;
                  color: #1885ad;
                  font-size: 14px;

                  outline: none;
                }
              }

              &.col-2 {
                grid-template-columns: 48% 48%;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  grid-row-gap: 20px;
                }
              }

              &.company-first-row {
                grid-template-columns: 48% 23% 23%;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  grid-row-gap: 20px;
                }
              }

              &.company-second-row {
                grid-template-columns: 68% 28%;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  grid-row-gap: 20px;
                }
              }

              &.sec-company-first-row {
                grid-template-columns: 23% 23% 48%;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  grid-row-gap: 20px;
                }
              }

              &.sec-company-second-row {
                grid-template-columns: 48% 23% 23%;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  grid-row-gap: 20px;
                }
              }

              &.sec-company-third-row {
                grid-template-columns: 30% 23% 23%;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  grid-row-gap: 20px;
                }
              }
            }
          }
        }
      }
    }

    .wizard-tab-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      flex-direction: column;

      @media (min-width: 300px) and (max-width: 630px) {
        padding-top: 50px;
      }

      .wizard-btn-next,
      .wizard-btn-finish {
        margin-right: 10px;
        width: 234px;
        height: 43px;
        background: #1885ad 0% 0% no-repeat padding-box;
        border-radius: 5px;
        border: none;
        color: #fff;
        font-size: 14px;

        margin-bottom: 15px;
        outline: none;
        text-align: center;
        justify-content: center;
      }

      .sub-option {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;

        .sepalator {
          margin: 0px 15px;
        }

        .wizard-btn-back {
          color: #1885ad;
          font-size: 14px;
          border: none;

          outline: none;
        }

        .wizard-btn-skip {
          color: #000;
          font-size: 14px;
          border: none;

          outline: none;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.wizard-date-picker {
  padding-top: 7px;
}
</style>
